import { render, staticRenderFns } from "./BodySlot.vue?vue&type=template&id=35266472&"
import script from "./BodySlot.vue?vue&type=script&lang=js&"
export * from "./BodySlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports